import React, { memo } from 'react';
import { Box, Typography, alpha, useTheme } from '@mui/material';
import type { Node } from '@antv/x6';
import energiaRaioImg from '../../../assets/energia_raio.png';
import { STATUS_COLORS } from './monitoramentoRedeUtils';
import type { DiagramNodeData } from './diagramaRedeUtils';

interface EnergiaRedeGraphNodeProps {
  node: Node;
}

const EnergiaRedeGraphNode: React.FC<EnergiaRedeGraphNodeProps> = ({ node }) => {
  const theme = useTheme();
  const data = node.getData<DiagramNodeData>();
  const diagramNode = data?.node;

  if (!diagramNode) {
    return (
      <Box sx={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Typography variant="caption" color="text.secondary">
          Nó inválido
        </Typography>
      </Box>
    );
  }

  const statusColor = STATUS_COLORS[diagramNode.monitor_status];

  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        px: 0.8,
        py: 0.8,
        borderRadius: 2,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-start',
        gap: 0.5,
        bgcolor: alpha(statusColor, theme.palette.mode === 'dark' ? 0.22 : 0.14),
        border: `2px solid ${statusColor}`,
        boxShadow: theme.shadows[2],
        overflow: 'hidden',
      }}
    >
      <Box
        component="img"
        src={energiaRaioImg}
        alt="Energia"
        draggable={false}
        sx={{
          width: 56,
          height: 56,
          objectFit: 'contain',
          flexShrink: 0,
          userSelect: 'none',
          pointerEvents: 'none',
        }}
      />

      <Typography
        variant="caption"
        fontWeight={700}
        noWrap
        title={diagramNode.nome}
        sx={{ width: '100%', textAlign: 'center', fontSize: '0.72rem', lineHeight: 1.2 }}
      >
        {diagramNode.nome}
      </Typography>
    </Box>
  );
};

export default memo(EnergiaRedeGraphNode, (prev, next) => {
  if (!prev.node || !next.node) return false;
  return !next.node.hasChanged('data');
});
